import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import strings from 'owa-strings/owa-common-strings';
import optionsStrings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface UnsubscribeDialogProps {
    onUnsubscribeCallback: () => void;
    dialogDetailMessage: string;
}

let containerDiv = null;

class UnsubscribeDialog extends React.Component<UnsubscribeDialogProps, {}> {
    render() {
        return (
            <Dialog
                hidden={false}
                dialogContentProps={{
                    type: DialogType.close,
                    title: optionsStrings.options_subscriptions_unsubscribeDialogTitle,
                    subText: this.props.dialogDetailMessage,
                }}
                onDismiss={closeDialog}>
                <DialogFooter>
                    <PrimaryButton
                        onClick={this.props.onUnsubscribeCallback}
                        text={optionsStrings.options_subscriptions_continue}
                    />
                    <DefaultButton onClick={closeDialog} text={strings.cancelButton} />
                </DialogFooter>
            </Dialog>
        );
    }
}

export function showUnsubscribeDialog(onUnsubscribeCallback: () => void, detailMessage: string) {
    containerDiv = document.createElement('div');
    containerDiv.id = 'unsubscribeBrandDialog';
    document.body.appendChild(containerDiv);

    ReactDOM.render(
        <UnsubscribeDialog
            onUnsubscribeCallback={() => {
                onUnsubscribeCallback();
                closeDialog();
            }}
            dialogDetailMessage={detailMessage}
        />,
        containerDiv
    );
}

const closeDialog = () => {
    if (containerDiv) {
        ReactDOM.unmountComponentAtNode(containerDiv);
        document.body.removeChild(containerDiv);
        containerDiv = null;
    }
};
